import React from 'react'

import { getIgnoredMatchesUrl } from '../../../api'
import Collection from './Collections'

const Ignores = () => <Collection getMatchesUrl={getIgnoredMatchesUrl} emptyPlaceholder="You haven't ignored any startups" />
export default Ignores
